import React from 'react';

import { cn } from '../../utils/classname';
import './input.scss';

interface InputProps {
  label: React.ReactNode;
  placeholder: string;
  name: string;
  value: string;
  error: boolean;
  handleChange: (e) => void;
}

const Input: React.FC<InputProps> = ({ value, label, placeholder, name, error, handleChange }) => {
  const inputClasses = cn('rc-input-field', error && 'rc-input-field--error');
  return (
    <div className="rc-input-container" data-component="input">
      <label className="rc-input-label">{label}</label>
      <input
        className={inputClasses}
        type="text"
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
      />
    </div>
  );
};

export default Input;
